<template>
  <div class="carousel">
    <button class="carousel_button carousel_close" @click="$emit('close')">
      <svg
        id="uuid-c0e55b50-25fb-462a-92bd-c60e30bf0f38"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 11.03998 11.05005"
      >
        <polygon
          points="6.57996 5.53003 11.03998 9.98999 9.97998 11.05005 5.51996 6.59003 1.06 11.05005 0 9.98999 4.45996 5.53003 0 1.06 1.06 0 5.51996 4.46002 9.97998 0 11.03998 1.06 6.57996 5.53003"
        ></polygon>
      </svg>
    </button>

    <div class="carousel_flex">
      <button class="carousel_button carousel_previous" @click="carouselBack">
        <svg
          width="18px"
          height="8px"
          viewBox="0 0 8 6"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g id="Welcome" stroke="none" stroke-width="1" fill-rule="evenodd">
            <g id="ophelia-maquette-V2-1440px" transform="translate(-1211.000000, -978.000000)">
              <g id="Nav-fond-foncé" transform="translate(593.000000, 930.000000)">
                <g id="Réserver-en-ligne" transform="translate(480.000000, 43.000000)">
                  <polygon
                    id="Page-1"
                    transform="translate(141.922000, 7.824000) rotate(-90.000000) translate(-141.922000, -7.824000) "
                    points="141.422 3.902 141.422 9.832 139.806 8.216 139.098 8.923 141.921 11.746 144.746 8.922 144.039 8.215 142.422 9.832 142.422 3.902"
                  ></polygon>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </button>

      <img
        class="carousel_image"
        :src="carousel[carouselKey].lg || carousel[carouselKey].original"
        alt="image"
      />

      <button class="carousel_button carousel_next" @click="carouselNext">
        <svg
          width="18px"
          height="8px"
          viewBox="0 0 8 6"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g id="Welcome" stroke="none" stroke-width="1" fill-rule="evenodd">
            <g id="ophelia-maquette-V2-1440px" transform="translate(-1211.000000, -978.000000)">
              <g id="Nav-fond-foncé" transform="translate(593.000000, 930.000000)">
                <g id="Réserver-en-ligne" transform="translate(480.000000, 43.000000)">
                  <polygon
                    id="Page-1"
                    transform="translate(141.922000, 7.824000) rotate(-90.000000) translate(-141.922000, -7.824000) "
                    points="141.422 3.902 141.422 9.832 139.806 8.216 139.098 8.923 141.921 11.746 144.746 8.922 144.039 8.215 142.422 9.832 142.422 3.902"
                  ></polygon>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </button>
    </div>

    <div class="carousel_container">
      <div class="carousel_thumbnails" style="transform: translateX(0rem)">
        <button
          class="carousel_thumbnail"
          :class="{ '-current': carouselKey === key }"
          v-for="(image, key) in carousel"
          @click="carouselKey = key"
        >
          <img :src="image.lg || image.original" alt="image" />
        </button>
      </div>
      <button class="carousel_button carousel_mobile" @click="carouselNext">
        <svg
          width="18px"
          height="8px"
          viewBox="0 0 8 6"
          version="1.1"
          xmlns="http://www.w3.org/2000/svg"
          xmlns:xlink="http://www.w3.org/1999/xlink"
        >
          <g id="Welcome" stroke="none" stroke-width="1" fill-rule="evenodd">
            <g id="ophelia-maquette-V2-1440px" transform="translate(-1211.000000, -978.000000)">
              <g id="Nav-fond-foncé" transform="translate(593.000000, 930.000000)">
                <g id="Réserver-en-ligne" transform="translate(480.000000, 43.000000)">
                  <polygon
                    id="Page-1"
                    transform="translate(141.922000, 7.824000) rotate(-90.000000) translate(-141.922000, -7.824000) "
                    points="141.422 3.902 141.422 9.832 139.806 8.216 139.098 8.923 141.921 11.746 144.746 8.922 144.039 8.215 142.422 9.832 142.422 3.902"
                  ></polygon>
                </g>
              </g>
            </g>
          </g>
        </svg>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Carousel',
  data() {
    return {
      carouselKey: 0,
    }
  },
  props: {
    carousel: {},
  },
  watch: {
    carousel(to) {
      if (!to) this.carouselKey = 0
    },
  },
  methods: {
    carouselNext() {
      if (this.carouselKey < this.carousel.length - 1) this.carouselKey += 1
      else {
        this.carouselKey = 0
      }
    },
    carouselBack() {
      if (this.carouselKey === 0) this.carouselKey = this.carousel.length - 1
      else {
        this.carouselKey -= 1
      }
    },
  },
}
</script>
